export default __webpack_public_path__ + "static/media/apple-app-store-badge-300x116.b64068e4.png";